import { render, staticRenderFns } from "./notifyTab.vue?vue&type=template&id=33665604"
import script from "./notifyTab.vue?vue&type=script&lang=js"
export * from "./notifyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports